import { useState } from 'react'

function PasswordModal({ show, onHide, onSubmit, configPassword }) {
  const [enteredPassword, setEnteredPassword] = useState('')

  const handleSubmit = () => {
    if (!enteredPassword) {
      alert('Please enter a password.')
      return
    }
    if (enteredPassword === configPassword) {
      onSubmit()
      onHide()
    } else {
      alert('Incorrect password. Please try again.')
      setEnteredPassword('') // Clear the field for retry
    }
  }

  const handleCancel = () => {
    window.location.href = '/'
  }

  return (
    <>
      {/* Modal backdrop - static, non-dismissible */}
      {show && <div className="modal-backdrop fade show"></div>}
      
      <div
        className={`modal fade ${show ? 'show' : ''}`}
        style={{ display: show ? 'block' : 'none' }}
        tabIndex="-1"
        aria-labelledby="passwordModalLabel"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="passwordModalLabel">
                Password required
              </h1>
              {/* No close button - force password entry */}
            </div>
            
            <div className="modal-body">
              <form onSubmit={(e) => { e.preventDefault(); handleSubmit() }}>
                {/* Hidden username field for accessibility */}
                <input
                  type="text"
                  name="username"
                  autoComplete="username"
                  style={{ display: 'none' }}
                  tabIndex="-1"
                  aria-hidden="true"
                  readOnly
                />
                <div className="mb-3">
                  <label htmlFor="passwordInput" className="form-label">
                    <i className="bi bi-lock-fill"></i> Please enter your password.
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="passwordInput"
                    placeholder="Password"
                    autoComplete="current-password"
                    value={enteredPassword}
                    onChange={(e) => setEnteredPassword(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
                  />
                </div>
              </form>
            </div>
            
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PasswordModal
